var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"copyToClipboardWrapper",staticClass:"ce-copyToClipboard"},[_c('div',{on:{"click":function($event){$event.preventDefault();}}},[_vm._t("default")],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }